import { ButtonGroup, ButtonIcon } from '@statsbomb/kitbag-components';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { RADAR_VIEW, radarViewAtom } from '@/atoms/radar';
import { OnboardingTooltip } from '@/components/onboarding/OnboardingTooltip';
import { OnboardingItemKey } from '@/types/userConfigs';

export const RadarViewToggle = () => {
  const { t } = useTranslation(['radar', 'onboarding']);
  const [view, setView] = useAtom(radarViewAtom);

  return (
    <ButtonGroup>
      <ButtonIcon
        icon="Radar"
        size="small"
        variant={view === RADAR_VIEW.RADAR ? 'primary' : 'ghost'}
        ariaPressed={view === RADAR_VIEW.RADAR}
        title={t('distributionView.toggleRadar')}
        onClick={() => setView(RADAR_VIEW.RADAR)}
      >
        {t('distributionView.toggleRadar')}
      </ButtonIcon>
      <OnboardingTooltip
        itemKey={OnboardingItemKey.RADAR_DISTRIBUTION_VIEW}
        header={t('radarDistributionView.header', { ns: 'onboarding' })}
        content={t('radarDistributionView.content', { ns: 'onboarding' })}
      >
        <ButtonIcon
          icon="ViolinPlot"
          size="small"
          variant={view === RADAR_VIEW.DISTRIBUTION ? 'primary' : 'ghost'}
          ariaPressed={view === RADAR_VIEW.DISTRIBUTION}
          title={t('distributionView.toggleDistribution')}
          onClick={() => setView(RADAR_VIEW.DISTRIBUTION)}
        >
          {t('distributionView.toggleDistribution')}
        </ButtonIcon>
      </OnboardingTooltip>
    </ButtonGroup>
  );
};
